import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../../content/service/gql.service-v2';
import { inboxLabelFrag } from './types/inbox-label.gql-types';
import { InboxLabelGridItemObject } from '@libs/types/src/inbox/object-type/inbox-label.object';
import { InboxMessageLabelCreateInput } from '@libs/types/src/inbox/input-type/inbox-message-label.create-input';
import { InboxMessageLabelUpdateInput } from '@libs/types/src/inbox/input-type/inbox-message-label.update-input';
import { IdsInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';

@Injectable({ providedIn: 'root' })
export class InboxLabelGqlService extends GqlServiceV2 {

    createInboxLabels(input: InboxMessageLabelCreateInput): Promise<InboxLabelGridItemObject[]> {
        return this.mutate(`
            mutation($input: InboxMessageLabelCreateInput!) {
                inboxLabel {
                    create(input: $input) {
                        ${inboxLabelFrag}
                    }
                }
            }`,
            { input },
        );
    }

    updateInboxLabels(input: InboxMessageLabelUpdateInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: InboxMessageLabelUpdateInput!) {
                inboxLabel {
                    update(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }

    deleteInboxLabels(input: IdsInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: IdsInput!) {
                inboxLabel {
                    delete(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }
}
